export const apartments = [
	{
		id: 1,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 1,
		number: 1,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 120.7,
		grossArea: 131.70,
		priceM2: 865.29,
		totalPrice: 115600,
		position: {
			en: 'East',
			bg: 'Изток',
			ru: 'Восток'
		},
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-1__ap-1.png']
	},{
		id: 2,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 1,
		number: 2,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 106.7,
		grossArea: 116.42,
		priceM2: 871.01,
		totalPrice: 102900,
		position: {
			en: 'East',
			bg: 'Изток',
			ru: 'Восток'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-1__ap-2.png']
	},{
		id: 3,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 1,
		number: 3,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 108.1,
		grossArea: 117.95,
		priceM2: 900.68,
		totalPrice: 107800,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-1__ap-3.png']
	},{
		id: 4,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 1,
		number: 4,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 103.6,
		grossArea: 113.04,
		priceM2: 931.23,
		totalPrice: 106800,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
    status: {
      en: 'reserved',
      bg: 'резервиран',
      ru: 'зарезервированный'
    },
		apartmentPlans: ['/img/floorplans/ab/AB__fl-1__ap-4.png']
	},{
		id: 5,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 1,
		number: 5,
		rooms: 2,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 88,
		grossArea: 96.02,
		priceM2: 875.07,
		totalPrice: 87900,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-1__ap-5.png']
	},{
		id: 6,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 1,
		number: 6,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 122.9,
		grossArea: 134.10,
		priceM2: 903.85,
		totalPrice: 126700,
		position: {
			en: 'Northwest',
			bg: 'Северозапад',
			ru: 'Северо-запад'
		},
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-1__ap-6.png']
	},{
		id: 7,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 1,
		number: 7,
		rooms: 2,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 75.4,
		grossArea: 85.19,
		priceM2: 777,
		totalPrice: 63920,
		position: {
			en: 'North',
			bg: 'Север',
			ru: 'Север'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
    },
		apartmentPlans: ['/img/floorplans/ab/AB__fl-1__ap-7.png']
	},{
		id: 8,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 1,
		number: 8,
		rooms: 4,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 121.3,
		grossArea: 132.35,
		priceM2: 897.55,
		totalPrice: 124200,
		position: {
			en: 'Northeast',
			bg: 'Североизток',
			ru: 'Северо-восток'
		},
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-1__ap-8.png']
	},{
		id: 9,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 2,
		number: 9,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 120.5,
		grossArea: 131.48,
		priceM2: 903.48,
		totalPrice: 120500,
		position: {
			en: 'East',
			bg: 'Изток',
			ru: 'Восток'
		},
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-2__ap-9.png']
	},{
		id: 10,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 2,
		number: 10,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 106.7,
		grossArea: 116.42,
		priceM2: 937.37,
		totalPrice: 110700,
		position: {
			en: 'East',
			bg: 'Изток',
			ru: 'Восток'
		},
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-2__ap-10.png']
	},{
		id: 11,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 2,
		number: 11,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 108.1,
		grossArea: 117.95,
		priceM2: 982.56,
		totalPrice: 117600,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-2__ap-11.png']
	},{
		id: 12,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 2,
		number: 12,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 103.6,
		grossArea: 117.05,
		priceM2: 1038.02,
		totalPrice: 121500,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
    status: {
      en: 'reserved',
      bg: 'резервиран',
      ru: 'зарезервированный'
    },
		apartmentPlans: ['/img/floorplans/ab/AB__fl-2__ap-12.png']
	},{
		id: 13,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 2,
		number: 13,
		rooms: 2,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 88,
		grossArea: 96.02,
		priceM2: 995.77,
		totalPrice: 99990,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-2__ap-13.png']
	},{
		id: 14,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 2,
		number: 14,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 122.9,
		grossArea: 138.85,
		priceM2: 1011.88,
		totalPrice: 140500,
		position: {
			en: 'Northwest',
			bg: 'Северозапад',
			ru: 'Северо-запад'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-2__ap-14.png']
	},{
		id: 15,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 2,
		number: 15,
		rooms: 2,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 75.4,
		grossArea: 82.27,
		priceM2: 892.12,
		totalPrice: 76700,
		position: {
			en: 'North',
			bg: 'Север',
			ru: 'Север'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-2__ap-15.png']
	},{
		id: 16,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 2,
		number: 16,
		rooms: 4,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 121.3,
		grossArea: 132.35,
		priceM2: 912.14,
		totalPrice: 126300,
		position: {
			en: 'Northeast',
			bg: 'Североизток',
			ru: 'Северо-восток'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-2__ap-16.png']
	},{
		id: 17,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 3,
		number: 17,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 120.5,
		grossArea: 131.48,
		priceM2: 1006.32,
		totalPrice: 134200,
		position: {
			en: 'East',
			bg: 'Изток',
			ru: 'Восток'
		},
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-3__ap-17.png']
	},{
		id: 18,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 3,
		number: 18,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 106.7,
		grossArea: 120.55,
		priceM2: 1099.13,
		totalPrice: 132500,
		position: {
			en: 'East',
			bg: 'Изток',
			ru: 'Восток'
		},
    status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
    },
		apartmentPlans: ['/img/floorplans/ab/AB__fl-3__ap-18.png']
	},{
		id: 19,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 3,
		number: 19,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 108.1,
		grossArea: 117.95,
		priceM2: 998.93,
		totalPrice: 119500,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
    status: {
      en: 'available',
      bg: 'свободен',
      ru: 'свободный'
    },
		apartmentPlans: ['/img/floorplans/ab/AB__fl-3__ap-19.png']
	},{
		id: 20,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 3,
		number: 20,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 103.6,
		grossArea: 117.05,
		priceM2: 1221.70,
		totalPrice: 143000,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
    status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
    },
		apartmentPlans: ['/img/floorplans/ab/AB__fl-3__ap-20.png']
	},{
		id: 21,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 3,
		number: 21,
		rooms: 2,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 88,
		grossArea: 96.02,
		priceM2: 1056.13,
		totalPrice: 106400,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-3__ap-21.png']
	},{
		id: 22,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 3,
		number: 22,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 122.9,
		grossArea: 134.10,
		priceM2: 1044.29,
		totalPrice: 146500,
		position: {
			en: 'Northwest',
			bg: 'Северозапад',
			ru: 'Северо-запад'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-3__ap-22.png']
	},{
		id: 23,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 3,
		number: 23,
		rooms: 2,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 75.4,
		grossArea: 82.27,
		priceM2: 997.77,
		totalPrice: 85900,
		position: {
			en: 'North',
			bg: 'Север',
			ru: 'Север'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-3__ap-23.png']
	},{
		id: 24,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 3,
		number: 24,
		rooms: 4,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 121.3,
		grossArea: 132.35,
		priceM2: 1007,
		totalPrice: 139600,
		position: {
			en: 'Northeast',
			bg: 'Североизток',
			ru: 'Северо-восток'
		},
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
		apartmentPlans: ['/img/floorplans/ab/AB__fl-3__ap-24.png']
	},{
		id: 25,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 4,
		number: 25,
		rooms: 4,
		type: {
			en: 'penthouse',
			bg: 'пентхаус',
			ru: 'пентхаус'
		},
		netArea: 247.69,
		grossArea: 310.83,
		priceM2: 1360.87,
		totalPrice: 423000,
		position: {
			en: 'East',
			bg: 'Изток',
			ru: 'Восток'
		},
    status: {
      en: 'reserved',
      bg: 'резервиран',
      ru: 'зарезервированный'
    },
		apartmentPlans: ['/img/floorplans/ab/AB__fl-4__ap-25.png']
	},{
		id: 26,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 4,
		number: 26,
		rooms: 4,
		type: {
			en: 'penthouse',
			bg: 'пентхаус',
			ru: 'пентхаус'
		},
		netArea: 231,
		grossArea: 287,
		priceM2: 1409.41,
		totalPrice: 404500,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
    status: {
      en: 'reserved',
      bg: 'резервиран',
      ru: 'зарезервированный'
    },
		apartmentPlans: ['/img/floorplans/ab/AB__fl-4__ap-26.png']
	},{
		id: 27,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 4,
		number: 27,
		rooms: 4,
		type: {
			en: 'penthouse',
			bg: 'пентхаус',
			ru: 'пентхаус'
		},
		netArea: 259.26,
		grossArea: 277.52,
		priceM2: 1235.43,
		totalPrice: 350000,
		position: {
			en: 'Northwest',
			bg: 'Северозапад',
			ru: 'Северо-запад'
		},
    status: {
      en: 'reserved',
      bg: 'резервиран',
      ru: 'зарезервированный'
    },
		apartmentPlans: ['/img/floorplans/ab/AB__fl-4__ap-27.png']
	},{
		id: 28,
		entrance: 'A-B',
		entranceUrl: 'ab',
		floor: 4,
		number: 28,
		rooms: 3,
		type: {
			en: 'penthouse',
			bg: 'пентхаус',
			ru: 'пентхаус'
		},
		netArea: 265.10,
		grossArea: 275,
		priceM2: 1127.27,
		totalPrice: 312800,
		position: {
			en: 'Northeast',
			bg: 'Североизток',
			ru: 'Северо-восток'
		},
    status: {
      en: 'available',
      bg: 'свободен',
      ru: 'свободный'
    },
		apartmentPlans: ['/img/floorplans/ab/AB__fl-4__ap-28.png']
	},{
		id: 29,
		entrance: 'C',
		entranceUrl: 'c',
		floor: 1,
		number: 1,
		rooms: 2,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 84.1,
		grossArea: 91.76,
		priceM2: 894.55,
		totalPrice: 85900,
		position: {
			en: 'East',
			bg: 'Изток',
			ru: 'Восток'
		},
    status: {
      en: 'reserved',
      bg: 'резервиран',
      ru: 'зарезервированный'
    },
		apartmentPlans: ['/img/floorplans/cd/C__fl-1__ap-1.png']
	},{
		id: 30,
		entrance: 'C',
		entranceUrl: 'c',
		floor: 1,
		number: 2,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 104,
		grossArea: 117.5,
		priceM2: 961.70,
		totalPrice: 113000,
		position: {
			en: 'East',
			bg: 'Изток',
			ru: 'Восток'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/cd/C__fl-1__ap-2.png']
	},{
		id: 31,
		entrance: 'C',
		entranceUrl: 'c',
		floor: 1,
		number: 3,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 97,
		grossArea: 109.59,
		priceM2: 985.49,
		totalPrice: 108000,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
    status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
    },
		apartmentPlans: ['/img/floorplans/cd/C__fl-1__ap-3.png']
	},{
		id: 32,
		entrance: 'C',
		entranceUrl: 'c',
		floor: 1,
		number: 4,
		rooms: 2,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 91.9,
		grossArea: 100.28,
		priceM2: 943.85,
		totalPrice: 99000,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/cd/C__fl-1__ap-4.png']
	},{
		id: 33,
		entrance: 'C',
		entranceUrl: 'c',
		floor: 2,
		number: 5,
		rooms: 5,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 188.1,
		grossArea: 205.24,
		priceM2: 997.60,
		totalPrice: 213800,
		position: {
			en: 'East',
			bg: 'Изток',
			ru: 'Восток'
		},
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
		apartmentPlans: ['/img/floorplans/cd/C__fl-2__ap-5.png']
	},{
		id: 34,
		entrance: 'C',
		entranceUrl: 'c',
		floor: 2,
		number: 6,
		rooms: 5,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 189,
		grossArea: 206.22,
		priceM2: 1100.55,
		totalPrice: 237600,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
		apartmentPlans: ['/img/floorplans/cd/C__fl-2__ap-6.png']
	},{
		id: 35,
		entrance: 'C',
		entranceUrl: 'c',
		floor: 3,
		number: 7,
		rooms: 5,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 188.1,
		grossArea: 205.24,
		priceM2: 1176.42,
		totalPrice: 252400,
		position: {
			en: 'East',
			bg: 'Изток',
			ru: 'Восток'
		},
    status: {
      en: 'available',
      bg: 'свободен',
      ru: 'свободный'
    },
		apartmentPlans: ['/img/floorplans/cd/C__fl-3__ap-7.png']
	},{
		id: 36,
		entrance: 'C',
		entranceUrl: 'c',
		floor: 3,
		number: 8,
		rooms: 5,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 189,
		grossArea: 206.22,
		priceM2: 1311.29,
		totalPrice: 282100,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
		apartmentPlans: ['/img/floorplans/cd/C__fl-3__ap-8.png']
	},{
		id: 37,
		entrance: 'C-D',
		entranceUrl: 'c',
		floor: 4,
		number: 9,
		rooms: 4,
		type: {
			en: 'penthouse',
			bg: 'пентхаус',
			ru: 'пентхаус'
		},
		netArea: 212.83,
		grossArea: 279.83,
		priceM2: 1307.94,
		totalPrice: 366000,
		position: {
			en: 'East',
			bg: 'Изток',
			ru: 'Восток'
		},
		status: {
			en: 'reserved',
			bg: 'резервиран',
			ru: 'зарезервированный'
		},
		apartmentPlans: ['/img/floorplans/cd/C__fl-4__ap-9.png']
	},{
		id: 38,
		entrance: 'C-D',
		entranceUrl: 'c',
		floor: 4,
		number: 10,
		rooms: 3,
		type: {
			en: 'penthouse',
			bg: 'пентхаус',
			ru: 'пентхаус'
		},
		netArea: 242.34,
		grossArea: 257.71,
		priceM2: 1360.23,
		totalPrice: 352000,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
		status: {
			en: 'reserved',
			bg: 'резервиран',
			ru: 'зарезервированный'
		},
		apartmentPlans: ['/img/floorplans/cd/C__fl-4__ap-10.png']
	},{
		id: 39,
		entrance: 'D',
		entranceUrl: 'd',
		floor: 1,
		number: 1,
		rooms: 2,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 71.2,
		grossArea: 77.69,
		priceM2: 870.21,
		totalPrice: 70000,
		position: {
			en: 'East',
			bg: 'Изток',
			ru: 'Восток'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/cd/D__fl-1__ap-1.png']
	},{
		id: 40,
		entrance: 'D',
		entranceUrl: 'd',
		floor: 1,
		number: 2,
		rooms: 2,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 74.1,
		grossArea: 83.72,
		priceM2: 895.84,
		totalPrice: 75000,
		position: {
			en: 'East',
			bg: 'Изток',
			ru: 'Восток'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/cd/D__fl-1__ap-2.png']
	},{
		id: 41,
		entrance: 'D',
		entranceUrl: 'd',
		floor: 1,
		number: 3,
		rooms: 2,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 77.6,
		grossArea: 87.67,
		priceM2: 975.25,
		totalPrice: 85500,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
    status: {
      en: 'reserved',
      bg: 'резервиран',
      ru: 'зарезервированный'
    },
		apartmentPlans: ['/img/floorplans/cd/D__fl-1__ap-3.png']
	},{
		id: 42,
		entrance: 'D',
		entranceUrl: 'd',
		floor: 1,
		number: 4,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 90.3,
		grossArea: 102.02,
		priceM2: 999.80,
		totalPrice: 102000,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/cd/D__fl-1__ap-4.png']
	},{
		id: 43,
		entrance: 'D',
		entranceUrl: 'd',
		floor: 2,
		number: 5,
		rooms: 4,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 150,
		grossArea: 163.67,
		priceM2: 1091.64,
		totalPrice: 187100,
		position: {
			en: 'East',
			bg: 'Изток',
			ru: 'Восток'
		},
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
		apartmentPlans: ['/img/floorplans/cd/D__fl-2__ap-5.png']
	},{
		id: 44,
		entrance: 'D',
		entranceUrl: 'd',
		floor: 2,
		number: 6,
		rooms: 4,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 167.9,
		grossArea: 189.69,
		priceM2: 1201.96,
		totalPrice: 228000,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
		status: {
			en: 'sold',
			bg: 'продаден',
			ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/cd/D__fl-2__ap-6.png']
	},{
		id: 45,
		entrance: 'D',
		entranceUrl: 'd',
		floor: 3,
		number: 7,
		rooms: 4,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 150,
		grossArea: 163.67,
		priceM2: 1150.65,
		totalPrice: 197000,
		position: {
			en: 'East',
			bg: 'Изток',
			ru: 'Восток'
		},
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
		apartmentPlans: ['/img/floorplans/cd/D__fl-3__ap-7.png']
	},{
		id: 46,
		entrance: 'D',
		entranceUrl: 'd',
		floor: 3,
		number: 8,
		rooms: 4,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 167.9,
		grossArea: 189.69,
		priceM2: 1465.55,
		totalPrice: 278000,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/cd/D__fl-3__ap-8.png']
	},{
		id: 47,
		entrance: 'C-D',
		entranceUrl: 'd',
		floor: 4,
		number: 9,
		rooms: 5,
		type: {
			en: 'penthouse',
			bg: 'пентхаус',
			ru: 'пентхаус'
		},
		netArea: 211.40,
		grossArea: 224.16,
		priceM2: 1284.80,
		totalPrice: 291000,
		position: {
			en: 'East',
			bg: 'Изток',
			ru: 'Восток'
		},
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
		apartmentPlans: ['/img/floorplans/cd/DE__fl-4__ap-9.png']
	},{
		id: 48,
		entrance: 'C-D',
		entranceUrl: 'd',
		floor: 4,
		number: 10,
		rooms: 5,
		type: {
			en: 'penthouse',
			bg: 'пентхаус',
			ru: 'пентхаус'
		},
		netArea: 225.13,
		grossArea: 239.26,
		priceM2: 1253.55,
		totalPrice: 300000,
		position: {
			en: 'West',
			bg: 'Запад',
			ru: 'Запад'
		},
    status: {
      en: 'reserved',
      bg: 'резервиран',
      ru: 'зарезервированный'
    },
		apartmentPlans: ['/img/floorplans/cd/DE__fl-4__ap-10.png']
	},{
		id: 49,
		entrance: 'E',
		entranceUrl: 'e',
		floor: 1,
		number: 1,
		rooms: 2,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 74.4,
		grossArea: 87.49,
		priceM2: 949.32,
		totalPrice: 79800,
		position: {
			en: 'Southeast',
			bg: 'Югоизток',
			ru: 'Юго-восток'
		},
		status: {
      en: 'sold',
      bg: 'продаден',
      ru: 'проданный'
		},
		apartmentPlans: ['/img/floorplans/e/E__fl-1__ap-1.png']
	},{
		id: 50,
		entrance: 'E',
		entranceUrl: 'e',
		floor: 1,
		number: 2,
		rooms: 3,
		type: {
			en: 'apartment',
			bg: 'апартамент',
			ru: 'апартамент'
		},
		netArea: 111.2,
		grossArea: 125.63,
		priceM2: 1034.78,
		totalPrice: 130000,
		position: {
			en: 'Southwest',
			bg: 'Югозапад',
			ru: 'Юго-запад'
		},
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
		apartmentPlans: ['/img/floorplans/e/E__fl-1__ap-2.png']
	},{
		id: 51,
		entrance: 'E',
		entranceUrl: 'e',
		floor: 2,
		number: 3,
		rooms: 5,
		type: {
			en: 'maisonette',
			bg: 'мезонет',
			ru: 'мезонет'
		},
		netArea: 185.38,
		grossArea: 215.59,
		priceM2: 1152.07,
		totalPrice: 247500,
		position: {
			en: 'Southeast',
			bg: 'Югоизток',
			ru: 'Юго-восток'
		},
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
		apartmentPlans: [
			'/img/floorplans/e/E__fl-2__ap-3.png',
			'/img/floorplans/e/E__fl-3__ap-3.png'
		]
	},{
		id: 52,
		entrance: 'E',
		entranceUrl: 'e',
		floor: 2,
		number: 4,
		rooms: 6,
		type: {
			en: 'maisonette',
			bg: 'мезонет',
			ru: 'мезонет'
		},
		netArea: 206.85,
		grossArea: 240.37,
		priceM2: 1246.08,
		totalPrice: 292000,
		position: {
			en: 'Southwest',
			bg: 'Югозапад',
			ru: 'Юго-запад'
		},
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
		apartmentPlans: [
			'/img/floorplans/e/E__fl-2__ap-4.png',
			'/img/floorplans/e/E__fl-3__ap-4.png'
		]
	},{
    id: 53,
    entrance: 'E',
    entranceUrl: 'e',
    floor: 4,
    number: 5,
    rooms: 6,
    type: {
      en: 'penthouse',
      bg: 'пентхаус',
      ru: 'пентхаус'
    },
    netArea: 176.34,
    grossArea: 233.84,
    priceM2: 1267.96,
    totalPrice: 296500,
    position: {
      en: 'Southwest',
      bg: 'Югозапад',
      ru: 'Юго-запад'
    },
		status: {
			en: 'available',
			bg: 'свободен',
			ru: 'свободный'
		},
    apartmentPlans: [
      '/img/floorplans/e/E__fl-4__ap-5.png'
    ]
  }
]

export const coordsAB = {
	1: [
		{ name: '8', number: '8', entrance: 'ab', coords: [205,12,500,46,664,90,664,34,894,92,894,709,134,709,150,511,205,511], shape: 'poly' },
		{ name: '7', number: '7', entrance: 'ab', coords: [136,705,783,710,783,1159,110,1157,110,963,140,963], shape: 'poly' },
		{ name: '6', number: '6', entrance: 'ab', coords: [108,1155,786,1155,784,1373,597,1373,594,1701,373,1700,373,2233,71,2233,67,1351,108,1353], shape: 'poly' },
		{ name: '5', number: '5', entrance: 'ab', coords: [597,1481,887,1481,887,2246,367,2240,371,1694,597,1694], shape: 'poly' },
		{ name: '4', number: '4', entrance: 'ab', coords: [890,1482,1427,2240], shape: 'rect' },
		{ name: '3', number: '3', entrance: 'ab', coords: [1428,1330,1892,2239], shape: 'rect' },
		{ name: '2', number: '2', entrance: 'ab', coords: [1426,360,1894,482,1892,1334,1426,1329], shape: 'poly' },
		{ name: '1', number: '1', entrance: 'ab', coords: [894,226,1424,366,1424,1191,890,1191], shape: 'poly' }
	],
	2: [
		{name:"9", number:"9", entrance: 'ab', coords:[862,217,1380,353,1380,1143,860,1143], shape:"poly"},
		{name:"10", number:"10",entrance: 'ab', coords:[1380,353,1823,472,1822,1288,1378,1287], shape:"poly"},
		{name:"11", number:"11",entrance: 'ab', coords:[1378,1283,1823,2167], shape:"rect"},
		{name:"12", number:"12",entrance: 'ab', coords:[864,1435,1376,2167], shape:"rect"},
		{name:"13", number:"13",entrance: 'ab', coords:[564,1431,860,1430,860,2167,359,2165,359,1638,564,1638], shape:"poly"},
		{name:"14", number:"14",entrance: 'ab', coords:[101,1113,751,1115,753,1327,564,1325,560,1635,353,1636,355,2170,64,2170,62,1308,102,1308], shape:"poly"},
		{name:"15", number:"15",entrance: 'ab', coords:[131,682,754,682,753,1113,102,1112,102,926,131,928], shape:"poly"},
		{name:"16", number:"16",entrance: 'ab', coords:[198,14,479,44,638,87,638,32,866,90,864,684,124,684,141,493,194,490], shape:"poly"}
	],
	3: [
		{name:"17", number:"17", entrance: 'ab', coords:[862,217,1380,353,1380,1143,860,1143], shape:"poly"},
		{name:"18", number:"18",entrance: 'ab', coords:[1380,353,1823,472,1822,1288,1378,1287], shape:"poly"},
		{name:"19", number:"19",entrance: 'ab', coords:[1378,1283,1823,2167], shape:"rect"},
		{name:"20", number:"20",entrance: 'ab', coords:[864,1435,1376,2167], shape:"rect"},
		{name:"21", number:"21",entrance: 'ab', coords:[564,1431,860,1430,860,2167,359,2165,359,1638,564,1638], shape:"poly"},
		{name:"22", number:"22",entrance: 'ab', coords:[101,1113,751,1115,753,1327,564,1325,560,1635,353,1636,355,2170,64,2170,62,1308,102,1308], shape:"poly"},
		{name:"23", number:"23",entrance: 'ab', coords:[131,682,754,682,753,1113,102,1112,102,926,131,928], shape:"poly"},
		{name:"24", number:"24",entrance: 'ab', coords:[198,14,479,44,638,87,638,32,866,90,864,684,124,684,141,493,194,490], shape:"poly"}
	],
	4: [
		{name: "25", number: "25", entrance: 'ab', coords:[855,1213,1406,1215,1406,1358,1885,1366,1882,498,859,230], shape: "poly"},
		{name: "26", number: "26", entrance: 'ab', coords:[1410,1371,1889,1376,1889,2312,860,2310,859,1523,1410,1521], shape: "poly"},
		{name: "27", number: "27", entrance: 'ab', coords:[62,1200,730,1202,732,1339,850,1339,849,2306,20,2304,20,1410,64,1408], shape: "poly"},
		{name: "28", number: "28", entrance: 'ab', coords:[154,21,441,48,635,99,631,44,850,102,847,1184,61,1184,59,1002,87,1000,84,717,101,534,154,534], shape: "poly"}
	]
}


export const coordsC = {
	1: [
		{ name: '1', number: '1', entrance: 'c', shape: 'poly', coords:[168,1535,882,1533,887,498,168,318] },
		{ name: '2', number: '2', entrance: 'c', shape: 'poly', coords:[910,502,1749,724,1751,1820,910,1827] },
		{ name: '3', number: '3', entrance: 'c', shape: 'poly', coords:[914,1853,1755,1853,1758,3115,1027,3123,1028,2026,910,2026] },
		{ name: '4', number: '4', entrance: 'c', shape: 'rect', coords:[166,2056,1007,3123] },
	],
	2: [
		{ name: '1', number: '5', entrance: 'c', shape: 'poly', coords:[171,219,1829,643,1827,1786,947,1788,947,1486,168,1482] },
		{ name: '2', number: '6', entrance: 'c', shape: 'poly', coords:[947,1816,1825,1816,1829,3130,170,3128,171,2028,949,2019] },
	],
	3: [
		{ name: '1', number: '7', entrance: 'c', shape: 'poly', coords:[171,219,1829,643,1827,1786,947,1788,947,1486,168,1482] },
		{ name: '2', number: '8', entrance: 'c', shape: 'poly', coords:[947,1816,1825,1816,1829,3130,170,3128,171,2028,949,2019] },
	]
}


export const coordsD = {
	1: [
		{ name: '1', number: '1', entrance: 'd', shape: 'poly', coords:[106,81,959,297,961,1144,106,1144] },
		{ name: '2', number: '2', entrance: 'd', shape: 'poly', coords:[991,318,1747,503,1740,788,1848,797,1845,1523,1415,1524,1413,1356,942,1355,945,1178,991,1175] },
		{ name: '3', number: '3', entrance: 'd', shape: 'rect', coords:[1057,1553,1857,2694] },
		{ name: '4', number: '4', entrance: 'd', shape: 'rect', coords:[104,1551,1046,2695] }
	],
	2: [
		{ name: '1', number: '5', entrance: 'd', shape: 'poly', coords:[104,88,1744,509,1733,791,1850,795,1850,1526,1198,1524,1194,1360,942,1355,940,1150,106,1152] },
		{ name: '2', number: '6', entrance: 'd', shape: 'rect', coords:[108,1553,1860,2692] }
	],
	3: [
		{ name: '1', number: '7', entrance: 'd', shape: 'poly', coords:[108,88,1746,505,1740,790,1846,791,1845,1525,940,1523,938,1148,104,1150] },
		{ name: '2', number: '8', entrance: 'd', shape: 'rect', coords:[106,1555,1860,2694] }
	]
}


export const coordsCD = {
  4: [
    {name: "9", number: "9", entrance: 'c', coords:[85,111,1001,351,994,971,518,969,520,895,282,893,283,814,91,809], shape: "poly"},
    {name: "10", number: "10", entrance: 'c', coords:[91,1105,515,1102,518,990,994,992,995,1711,94,1711], shape: "poly"},
    {name: "9", number: "9", entrance: 'd', coords:[1013,354,1866,575,1870,715,1918,718,1918,1107,1448,1100,1444,913,1013,907], shape: "poly"},
    {name: "10", number: "10", entrance: 'd', coords:[1013,1123,1919,1118,1919,1711,1009,1711], shape: "poly"}
  ]
}


export const coordsE = {
	1: [
		{ name: '1', number: '1', entrance: 'e', shape: 'poly', coords:[229,187,231,770,503,772,504,1083,1875,1088,1875,535,1660,534,1651,265,1188,267,1190,196,1047,196,1049,12,356,9,351,180] },
		{ name: '2', number: '2', entrance: 'e', shape: 'poly', coords:[236,1837,239,2415,372,2417,370,2641,1969,2641,1971,1857,1884,1855,1883,1117,989,1118,989,1417,716,1420,706,1839] }
	],
	2: [
		{ name: '1', number: '3', entrance: 'e', shape: 'poly', coords:[236,200,234,780,506,780,510,1087,1886,1089,1883,525,1670,523,1669,256,1178,256,1178,186,1045,184,1045,19,365,21,365,198] },
		{ name: '2', number: '4', entrance: 'e', shape: 'poly', coords:[231,1832,231,2417,383,2413,381,2640,1969,2636,1974,1857,1879,1857,1886,1118,997,1122,994,1415,716,1419,711,1836] }
	],
	3: [
		{ name: '1', number: '3', type: 'maisonette', entrance: 'e', shape: 'poly', coords:[301,196,296,1246,609,1246,610,1456,1883,1456,1883,512,1670,511,1667,247,1202,247,1199,177,1073,175,1075,16,427,16,428,194] },
		{ name: '2', number: '4', type: 'maisonette', entrance: 'e', shape: 'poly', coords:[303,1573,301,2317,446,2315,446,2530,1967,2538,1969,1781,1893,1779,1886,1491,605,1486,605,1574] }
	],
  4: [
    { name: '1', number: '5', entrance: 'e', shape: 'poly', coords:[213,194,1071,194,1071,498,1741,498,1743,2325,345,2322,343,2041,214,2043,218,1724,656,1714,653,1007,462,1005,456,724,214,717] }
  ]
}



// WEBPACK FOOTER //
// ./src/utils/redux/config/apartments.js